(function () {
  // --- 1) Jezik (Shopify locale) ---
  var locale = (document.documentElement.getAttribute("lang") || "").toLowerCase();
  var lang = locale.split("-")[0];

  // --- 2) Prevodne tabele: samo barve ---
  var COLORS = {
    sl: { black: "Črna", orange: "Oranžna", grey: "Siva", beige: "Bež" },
    hr: { black: "Crna", orange: "Narančasta", grey: "Siva", beige: "Bež" },
    sk: { black: "Čierna", orange: "Oranžová", grey: "Sivá", beige: "Béžová" },
    cs: { black: "Černá", orange: "Oranžová", grey: "Šedá", beige: "Béžová" },
    hu: { black: "Fekete", orange: "Narancs", grey: "Szürke", beige: "Bézs" },
    it: { black: "Nero", orange: "Arancione", grey: "Grigio", beige: "Beige" },
    pl: { black: "Czarny", orange: "Pomarańczowy", grey: "Szary", beige: "Beżowy" },
    ro: { black: "Negru", orange: "Portocaliu", grey: "Gri", beige: "Bej" },
    el: { black: "Μαύρο", orange: "Πορτοκαλί", grey: "Γκρι", beige: "Μπεζ" },
    bg: { black: "Черен", orange: "Оранжев", grey: "Сив", beige: "Бежов" }
  };

  var t = COLORS[lang];
  if (!t) return;

  // --- 3) Sinonimi -> kanonični ključ ---
  // POMEMBNO: "bez" (brez) NE sme mapirati v "beige"
  var DICT = {
    "crna": "black",
    "črna": "black",
    "black": "black",

    "oranžna": "orange",
    "oranzna": "orange",
    "narančasta": "orange",
    "narancasta": "orange",
    "orange": "orange",

    "siva": "grey",
    "sivá": "grey",
    "šedá": "grey",
    "sedá": "grey",
    "grey": "grey",
    "gray": "grey",
    "grigio": "grey",

    "bež": "beige",
    "béžová": "beige",
    "beige": "beige"
  };

  function escRe(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  var terms = Object.keys(DICT)
    .sort(function (a, b) { return b.length - a.length; })
    .map(escRe)
    .join("|");

  var RE = new RegExp("(^|[^\\p{L}])(" + terms + ")(?=[^\\p{L}]|$)", "giu");

  function translateString(str) {
    if (!str || typeof str !== "string") return str;
    return str.replace(RE, function (m, pre, word) {
      var key = DICT[String(word).toLowerCase()];
      if (!key) return m;
      var repl = t[key] || word;
      return pre + repl;
    });
  }

  // --- 4) SCOPING (Horizon) ---
  // razširjen scope: product, quick add, drawers, cart, modals, sections, web components
  var SCOPE_SELECTORS = [
    // product page / sections
    ".product",
    ".product__info",
    ".product__info-wrapper",
    ".product-info",
    ".product-form",
    "[data-product-form]",
    "[data-product]",
    "[data-product-id]",
    ".shopify-section",

    // variant pickers (pogosti patterni)
    ".variant-picker",
    ".product-variants",
    ".product-options",
    "[data-variant-picker]",
    "[data-option]",
    "[data-options]",
    "[data-selected-variant]",
    "variant-picker",
    "product-variant-picker",
    "product-form",
    "product-info",

    // quick add / quick view / modal
    ".quick-add",
    ".quick-add-modal",
    ".modal",
    ".modal__content",
    ".product-modal",
    "quick-add-modal",
    "quick-add",
    "modal-dialog",

    // cart / drawer / notification
    ".cart",
    ".cart__items",
    ".cart-drawer",
    ".drawer",
    ".drawer__content",
    "#CartDrawer",
    "cart-drawer",
    ".cart-notification",
    "#cart-notification",
    "cart-notification",

    // buy buttons area
    ".buy-buttons",
    ".product__buttons",
    ".product__submit",
    "form[action*='/cart/add']"
  ].join(",");

  // izključimo header/footer/nav/logo območja
  var EXCLUDE_CLOSEST = [
    "header",
    ".header",
    ".shopify-section-header",
    ".sticky-header",
    "nav",
    ".nav",
    "footer",
    ".footer",
    ".shopify-section-footer",
    ".announcement-bar",
    ".header__heading",
    ".header__icon",
    ".logo",
    ".site-header",
    ".site-footer"
  ].join(",");

  function shouldSkipTextNode(tn) {
    var p = tn && tn.parentElement;
    if (!p) return true;

    var tag = p.tagName;
    if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT" || tag === "TEXTAREA") return true;
    if (p.closest && p.closest('script[type="application/ld+json"]')) return true;

    if (p.closest && p.closest(EXCLUDE_CLOSEST)) return true;

    return false;
  }

  var ATTRS = ["aria-label", "title"];

  function patchElementAttrs(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.closest && el.closest(EXCLUDE_CLOSEST)) return;

    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      var v = el.getAttribute(a);
      if (!v) continue;
      var nv = translateString(v);
      if (nv !== v) el.setAttribute(a, nv);
    }
  }

  function patchRoot(root) {
    if (!root) return;
    if (root.closest && root.closest(EXCLUDE_CLOSEST)) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var tn;
    while ((tn = walker.nextNode())) {
      if (shouldSkipTextNode(tn)) continue;
      var v = tn.nodeValue;
      if (!v) continue;
      var nv = translateString(v);
      if (nv !== v) tn.nodeValue = nv;
    }

    if (root.querySelectorAll) {
      var els = root.querySelectorAll("[aria-label],[title]");
      for (var j = 0; j < els.length; j++) patchElementAttrs(els[j]);
    }
  }

  function getScopes() {
    if (!document.body) return [];
    var list = document.querySelectorAll(SCOPE_SELECTORS);
    if (list && list.length) return Array.prototype.slice.call(list);
    return [];
  }

  // fallback: patchaj samo elemente, kjer je zelo verjetno, da gre za variante/cart tekst
  function getFallbackTargets() {
    if (!document.body || !document.querySelectorAll) return [];
    var q = [
      "[name='options[]']",
      "[data-option]",
      "[data-options]",
      "[data-variant]",
      "[data-variant-title]",
      "[data-selected-variant]",
      ".product-form",
      ".cart-drawer",
      "#CartDrawer",
      "cart-drawer",
      ".cart-notification",
      "#cart-notification",
      "cart-notification"
    ].join(",");
    var els = document.querySelectorAll(q);
    return els && els.length ? Array.prototype.slice.call(els) : [];
  }

  var running = false;
  function run() {
    if (running) return;
    running = true;
    try {
      var scopes = getScopes();
      if (scopes.length) {
        for (var i = 0; i < scopes.length; i++) patchRoot(scopes[i]);
      } else {
        // fallback (še vedno ne posegamo v header/footer)
        var fb = getFallbackTargets();
        for (var k = 0; k < fb.length; k++) patchRoot(fb[k]);
      }
    } finally {
      running = false;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { run(); });
  } else {
    run();
  }

  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];

      if (m.type === "characterData") {
        var pe = m.target && m.target.parentElement;
        if (!pe) continue;
        if (pe.closest && pe.closest(EXCLUDE_CLOSEST)) continue;

        var scope = pe.closest ? pe.closest(SCOPE_SELECTORS) : null;
        if (scope) patchRoot(scope);
        else run();
      } else if (m.addedNodes && m.addedNodes.length) {
        for (var k = 0; k < m.addedNodes.length; k++) {
          var n = m.addedNodes[k];
          var el = (n.nodeType === 1) ? n : (n.nodeType === 3 ? n.parentElement : null);
          if (!el) continue;
          if (el.closest && el.closest(EXCLUDE_CLOSEST)) continue;

          var scope2 = el.closest ? el.closest(SCOPE_SELECTORS) : null;
          if (scope2) patchRoot(scope2);
          else run();
        }
      }
    }
  });

  function startObs() {
    if (!document.body) return;
    obs.observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  if (document.body) startObs();
  else document.addEventListener("DOMContentLoaded", startObs);
})();
